import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleApiService } from 'src/app/core/services/mobile-api/vehicle-api/vehicle-api.service';
import {
	ILicensePlateRequest,
	IVehicleVendorInformation,
	IVinInformation
} from 'src/app/core/services/mobile-api/vehicle-api/vehicle-api.model';
import { map, Observable } from 'rxjs';
import { IMetadata } from 'src/app/core/services/mobile-api/metadata-api/metadata-api.model';
import { MetadataService } from 'src/app/core/services/metadata/metadata.service';
import { MetadataEnum } from 'src/app/core/services/metadata/metadata.model';
import { compose, sortBy, uniqBy } from 'lodash/fp';
import { LoanApplicationService } from 'src/app/core/services/loan-application/loan-application.service';
import { Router } from '@angular/router';

@Component({
	selector: 'op-vehicle-license',
	templateUrl: './vehicle-license.component.html',
	styleUrls: ['./vehicle-license.component.scss']
})
export class VehicleLicenseComponent implements OnInit {
	@Output() vinResults = new EventEmitter<IVinInformation>();
	@Output() vendorDetails = new EventEmitter<IVehicleVendorInformation>();
	formGroup: FormGroup;
	stateList$: Observable<IMetadata[]>;
	notFound: boolean = false;
	submitted: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
		private vehicleApiService: VehicleApiService,
		private loanAppService: LoanApplicationService,
		private metadataService: MetadataService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.createForm();
		this.stateList$ = this.metadataService
			.select(MetadataEnum.USState)
			.pipe(map((val) => compose(sortBy('text'), uniqBy('text'))(val as any) as any[]));
	}

	private createForm(): void {
		this.formGroup = this.formBuilder.group({
			plate: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(10)]],
			state: ['', [Validators.required]]
		});
	}

	reloadPage(): void {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([this.router?.url]);
	}

	resetForm(): void {
		this.formGroup.reset();
		this.formGroup.get('plate').enable();
		this.formGroup.get('state').enable();
		this.formGroup.markAsPristine();
		this.formGroup.markAsUntouched();
		this.notFound = false;
		this.submitted = false;
	}

	onSubmit(): void {
		if (this.formGroup.invalid) {
			return;
		}

		const iLicensePlateRequest: ILicensePlateRequest = this.formGroup.value;
		this.vehicleApiService.getVinByLicensePlate(iLicensePlateRequest, this.loanAppService.loanApplicationId).subscribe({
			next: (response) => {
				this.submitted = true;
				this.formGroup.get('plate').disable();
				this.formGroup.get('state').disable();
				if (response?.vehicle) {
					this.notFound = false;

					const vehicle = response.vehicle;
					const vinInfo: IVinInformation = {
						vin: vehicle.vin,
						vinResults: {
							data: vehicle,
							licensePlate: iLicensePlateRequest.plate,
							state: iLicensePlateRequest.state
						}
					};
					this.vinResults.emit(vinInfo);
					this.vendorDetails.emit({
						vendorName: vehicle.vendorName,
						vendorVehicleId: vehicle.vendorVehicleId
					});
				} else {
					this.notFound = true;
				}
			},
			error: (err) => {
				this.submitted = true;
				this.notFound = true;
			}
		});
	}
}
